// src/pages/STEMSubjectsDashboard.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const STEMSubjectsDashboard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const paymentStatus = localStorage.getItem("paymentStatus");
    const paidPlan = JSON.parse(localStorage.getItem("paidPlan"));

    if (paymentStatus !== "success" || !paidPlan || !paidPlan.features.includes("STEM Subjects")) {
      // Redirect to checkout if payment is not successful or if the plan doesn't include STEM Subjects
      navigate("/checkout");
    }
  }, [navigate]);

  return (
    <div>
      <h1>STEM Subjects Dashboard</h1>
      {/* STEM Subjects features and content */}
    </div>
  );
};

export default STEMSubjectsDashboard;
